import { api, endpoints } from "./api";
import { AxiosPromise } from "axios";
import { BaseApiPaging } from "api/types";

const fetch = (
  skip: number,
  take: number,
  searchPhrase: string,
  filter: string,
  orderBy: string = ""
): AxiosPromise<BaseApiPaging<EmailApi>> => {
  return api.get<BaseApiPaging<EmailApi>>(endpoints.EMAILS.GET(skip, take, searchPhrase, filter, orderBy));
};

const fetchById = (emailId: number): AxiosPromise<EmailDetailsApi> => {
  return api.get<EmailDetailsApi>(endpoints.EMAILS.GET_BY_ID(emailId));
};

const deleteDictionary = (emailId: number): Promise<void> => {
  return api.delete(endpoints.EMAILS.DELETE(emailId));
};

export const emailsApi = {
  fetch,
  fetchById,
  delete: deleteDictionary,
};

// The list never carries the body (avg 18 KB per email): the preview fetches it by id.
export interface EmailApi {
  id: number;
  subject: string;
  recipient: string;
  sentTime?: Date;
  plannedDeliveryTime?: Date;
  createdDate: Date;
}

export interface EmailDetailsApi extends EmailApi {
  body: string;
}
